module.exports = __webpack_public_path__ + "img/tuxfamily.png";